//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drawer from '@/components/drawer';
import jsonEdit from '@/components/jsonEdit/index.vue';
export default {
  name: 'EditAgentAppDetail',
  components: { Drawer, jsonEdit },
  props: {
    row: { type: Object, default: () => {} },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showJson: false,
      currentJson: '',
      jsonData: '{}',
      form: {
        id: '',
        name: '',
        description: '',
        type: '',
        graph: '',
        graph_draft: '',
        is_system: false,
        version: '',
      },
      rules: {
        name: [{ required: true, message: '请输入应用名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择应用类型', trigger: 'blur' }],
        description: [{ required: true, message: '请填写描述', trigger: 'blur' }],
      },
    };
  },
  watch: {
    visible() {
      if (this.visible) {
        console.log(this.row.id);
        if (this.row.id) {
          this.$request({
            url: this.$api.getAgentAppById,
            data: {
              id: this.row.id,
            },
          }).then((res) => {
            this.form = res.agent_app;
          });
        }
      }
    },
  },
  mounted() {},
  methods: {
    close() {
      this.$emit('close');
    },
    onSubmit() {
      console.log('submit!');
    },
    openJsonEdit(key) {
      this.jsonData = this.form[key];
      this.currentJson = key;
      this.$nextTick(() => {
        this.showJson = true;
      });
    },
    saveJson(json) {
      this.form[this.currentJson] = JSON.stringify(JSON.parse(json));
      this.$nextTick(() => {
        this.showJson = false;
      });
    },
    updateAgentApp() {
      this.$refs.form.validate((valid) => {
        // valid
        console.log('%c Line:77 🥤 valid', 'color:#ffdd4d', valid);
        if (valid) {
          // updateAgentApp
          this.$request({
            url: this.$api.updateAgentApp,
            data: {
              id: this.row.id,
              agent_app: {
                ...this.form,
              },
            },
          }).then((res) => {
            console.log('%c Line:130 🍫 res', 'color:#33a5ff', res);
            this.$emit('refresh');
            this.close();
          });
        } else {
          this.$message.warning('请填写必填项');
        }
      });

      // console.log('%c Line:140 🌮 this.form', 'color:#fca650', this.form);
    },
  },
};
